import { Directive } from '@angular/core';
import {
  CoverageType,
  getBuildingTypeLabel,
  getConstructionTypeLabel,
  getCoverageTypeLabel,
  getHeatingSystemLabel,
  getRoofTypeLabel,
  getSecurityMeasureLabel,
} from 'src/app/_enums/building.enums';
import { compareArrays, getBooleanLabel } from 'src/app/_helpers/utils';
import { BuildingClaimInfo } from 'src/app/_types/building.types';
import { BuildingInsuranceMetatadata } from 'src/app/_types/lead.types';

import { BaseMetadataComponent } from '../base-metadata.component';

@Directive()
export abstract class BuildingMetadataComponentAbstract extends BaseMetadataComponent<BuildingInsuranceMetatadata> {
  getBuildingTypeLabel = getBuildingTypeLabel;

  getSecurityMeasureLabel = getSecurityMeasureLabel;

  getHeatingSystemLabel = getHeatingSystemLabel;

  getRoofTypeLabel = getRoofTypeLabel;

  getCoverageTypeLabel = getCoverageTypeLabel;

  getConstructionTypeLabel = getConstructionTypeLabel;

  getBuildingClaimDetails(details: BuildingClaimInfo[]): string[] {
    return details.map(
      (x) =>
        `${getCoverageTypeLabel(x.type as CoverageType)}, ${x.count} fois, ${
          x.cost
        }CHF`
    );
  }

  getBooleanLabel = getBooleanLabel;

  compareArrays = compareArrays;

  compareClaimDetails(arr1: BuildingClaimInfo[], arr2: BuildingClaimInfo[]) {
    return compareArrays(
      arr1,
      arr2,
      (a: BuildingClaimInfo, b: BuildingClaimInfo) =>
        a.cost === b.cost && a.count === b.count && a.type === b.type
    );
  }

  displayQuestionnaire(metadata: BuildingInsuranceMetatadata) {
    return (
      !!metadata?.reason ||
      !!metadata?.companyName ||
      !!metadata?.claimDetails ||
      !!(metadata?.anyClaims !== null && metadata?.anyClaims !== undefined) ||
      !!(metadata?.pastInsured !== null && metadata?.pastInsured !== undefined)
    );
  }

  displayComplementaryInfo(metadata: BuildingInsuranceMetatadata) {
    return (
      !!metadata?.use ||
      !!metadata?.noOfTrade ||
      !!metadata?.noOfApartment ||
      !!metadata?.commercialArea
    );
  }

  displayBuildingInfo(metadata: BuildingInsuranceMetatadata) {
    return (
      !!metadata?.buildingType ||
      !!metadata?.heatingSystem ||
      !!metadata?.yearOfConstruction ||
      !!metadata?.typeOfRoof ||
      !!metadata?.sum ||
      !!metadata?.franchise ||
      !!metadata?.securityMeasures ||
      !!metadata?.sumInsured ||
      !!metadata?.typeOfConstruction ||
      !!metadata?.benefits
    );
  }
}
